import React, { Component } from "react";
import { Link } from "react-router-dom";
import { setJwt } from "../services/httpService";
import { getUser, getUserSystems } from "../services/userService";
import { SystemsUsers } from './systemsUsers';
import Modal from "react-bootstrap/Modal";
import "./dashboard.css";
import "../index.css";
import ReactExport from "react-data-export";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';
import { toast } from "react-toastify";
import BackGroundRectangle from "../components/backgroundRect";
import { getCourses, saveCourse } from "../services/companyService";
import { text } from "@fortawesome/fontawesome-svg-core";

class SimplCourses extends Component {
    state = {
      systems: [],
      currentPage: 1,
      videosPerPage: 2, // videos per page showed
    };
  
    async componentDidMount() {
      try {
        const usernameprops = this.props.match.params.username;
        const jwt = localStorage.getItem("token");
        setJwt(jwt);
        const user = await getUser();
        const username = user.data.data.username;
        const firstName = user.data.data.firstName;
        const lastName = user.data.data.lastName;
        const emailAddress = user.data.data.emailAddress;
        const admin = user.data.data.admin;
        this.setState({ username, firstName, lastName, emailAddress, admin });
  
        const conditionsAgreed = false;
        this.setState({ conditionsAgreed });
  
        const userSystems = (await getUserSystems()).data.data;
        this.setState({ companyName: user.data.data.company });
  
        await getCourses().then(res => {
          this.setState({ videos: res.data.data.courses, allVideos: res.data.data.courses });
        });
  
      } catch (e){
        window.location.reload();
      }
    }
  
    handleSearch = (e) => {
      const value = e.target.value.toLowerCase();
      let videos = [];
      if (e.target.value === "") {
        videos = this.state.allVideos;
      } else {
        videos = this.state.allVideos.filter((video) => { 
          return video.title.toLowerCase().includes(value) ||
          video.description.toLowerCase().includes(value);
        });
      }
      this.setState({ videos, currentPage: 1 }); // reset to page 1 on search
    }
  
    handlePageChange = (pageNumber) => {
      this.setState({ currentPage: pageNumber });
    }
  
    render() {
      const { videos = [], currentPage, videosPerPage } = this.state;
      const indexOfLastVideo = currentPage * videosPerPage;
      const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
      const currentVideos = videos.slice(indexOfFirstVideo, indexOfLastVideo);
      const totalPages = Math.ceil(videos.length / videosPerPage);
  
      const styles = {

        
        cardWrapper: {
          backgroundColor: 'white',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          borderRadius: '20px',
          width: '100%',
          maxWidth: '3000px',
          margin: '0 auto',
          boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.2)'
        },
        courseCard: {
          display: 'flex',
          alignItems: 'flex-start',
          gap: '20px',
          marginBottom: '40px',
          borderBottom: '1px solid #eee',
          paddingBottom: '20px'
        },
        courseImage: {
          width: '160px',
          height: '100px',
          objectFit: 'cover',
          borderRadius: '8px'
        },
        courseContent: {
          flex: 1
        },
        courseTitle: {
          fontSize: '22px',
          fontWeight: 'bold',
          color: 'rgba(56, 114, 168, 1)'
        },
        courseDescription: {
          fontSize: '14px',
          color: '#333',
          marginBottom: '10px'
        }
        
      };
  
      return (
        <React.Fragment>
          <div
            style={{
              width: "50%",
              position: "absolute",
              left: "50%",
              transform: "translateX(-45%)",
              marginTop: "150px",
              paddingBottom: "100px",
              zIndex: 1,
            }}
          >
            <div style={{ marginRight: "25px" }}>
              <div className="d-flex align-items-center text-center justify-content-center mb-2 w-100">
                <div className="video-courses-banner">
                  <h1 className="video-courses-title">Video Courses</h1>
                </div>
                 {this.state.companyName === "Simpl Global Inc." && this.state.admin && (
                    <div className="mb-2">
                    <button
                        className="btn p-0 border-0 bg-transparent"
                         style={{
                          visibility: "hidden",
                          position: "absolute",
                          right: "50%",
                          top: "86px",
                          transition: "transform 0.3s ease", //Transition for smooth scaling
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    >
                        <UploadVideoModal videos={this.state.allVideos} />
                    </button>
                    </div>
                )}
                
              </div> 


              <div className="d-flex flex-column align-items-start ms-5 mb-3">
                {/* upload btn (only for admin de Simpl Global Inc.) */}
               

                {/* search bar */}
                <div className="p-2 bg-light rounded shadow-sm" style={{ width: "100%" }}>
                    <div className="d-flex justify-content-center align-items-center">
                    <input
                        className="form-control"
                        style={{
                        width: "100%",
                        fontFamily: "Arial",
                        fontWeight: "300",
                        color: "#898989",
                        fontSize: "14px",
                        height: "35px",
                        }}
                        type="text"
                        name="search"
                        placeholder="Search by keyword"
                        onChange={this.handleSearch}
                    />
                    </div>
                </div>
                </div>
              {/* Video List */}
              <div style={styles.cardWrapper}>
                {currentVideos.map((video) => (
                  <div key={video.url.slice(17)}>
                    <div style={styles.courseCard}>
                      <img
                        src="https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=600"
                        alt={video.title}
                        style={styles.courseImage}
                      />
                      <div style={styles.courseContent}>
                        <h4 style={styles.courseTitle}>{video.title}</h4>
                        <p style={styles.courseDescription}>{video.description}</p>
                        <a
                          href={video.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn"
                          style={{
                            backgroundColor: '#e4bb34',
                            border: 'none',
                            color: 'white',
                            padding: '10px 20px',
                            fontSize: '16px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                          }}
                          onMouseOver={(e) => e.target.style.backgroundColor = '#f0c955ff'}
                          onMouseOut={(e) => e.target.style.backgroundColor = '#e4bb34'}
                        >
                          Explore
                        </a>
                      </div>
                    </div>
                    <hr style={{ margin: "10px" }} />
                  </div>
                ))}
  
                {/* Pagination */}
                {videos.length > videosPerPage && (
                  <div className="d-flex justify-content-center mt-4">
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => this.handlePageChange(currentPage - 1)}>Previous</button>
                        </li>
                        {Array.from({ length: totalPages }, (_, i) => (
                          <li key={i + 1} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                            <button className="page-link" onClick={() => this.handlePageChange(i + 1)}>{i + 1}</button>
                          </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => this.handlePageChange(currentPage + 1)}>Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
  
         {/*  <BackGroundRectangle /> */}
        </React.Fragment>
      );
    }
  }

export default SimplCourses;

class UploadVideoModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false,
      loaded: true
    };

    this.onClickHandler = async () => {
      const videos = this.props.videos;
      const newVideo = {
        "title": this.state.title,
        "url": this.state.url,
        "description": this.state.description
      }
      videos.push(newVideo);
      await saveCourse(videos)
      .then(res => { // then print response status
        console.log(res.statusText);
        if (res.statusText === 'OK') toast.success("Video Saved!");
        // this.setState({ allVideos: videos, videos });
        this.handleHide();
      })
    }

    this.title = (e) => {
      this.setState({title: e.target.value});
      console.log("title", this.state.title);
    }

    this.url = (e) => {
      this.setState({url: e.target.value});
      console.log("desc", this.state.url);
    }
    
    this.description = (e) => {
      this.setState({description: e.target.value});
    }

    this.handleShow = () => {
      this.setState({ show: true });
    };
    
    this.handleHide = () => {
      this.setState({ show: false });
    };
  }
  
  render() {
    console.log("videos", this.props.videos);
    return (
      <>
        <button
          onClick={this.handleShow}
          className="btn btn-shadow-none"
          style={{ padding: "0" }}
        >
          <FontAwesomeIcon
            icon="plus-circle"
            size="2x"
            color="#ffc000"
            title="Save new video"
          />
        </button>

        <Modal
          show={this.state.show}
          onHide={this.handleHide}
          dialogClassName="modal-50w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Save New Video
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <div 
              className="d-flex justify-content-around mb-3"
            >
                <label className="basicParagraph" style={{width: "150px"}}>Enter the title here: </label>
                <input 
                type="text" 
                name="Title" 
                onChange={e => this.title(e)} 
                // style={{width: "180px", marginLeft: "10px"}}
                style={{
                  width: "200px",
                  fontFamily: "arial",
                  fontWeight: "250",
                  color: "#784feb",
                  fontSize: "12px",
                  border: "2px solid rgb(206, 204, 204)",
                  borderRadius: "4px",
                  // height: "30px",
                  paddingBottom: "0px",
                  placeholder: "Required"
                }}
                />
            </div>
            <div 
              className="d-flex justify-content-around mb-3"
            >
                <label className="basicParagraph" style={{width: "150px"}}>Enter the url here: </label>
                <input 
                type="text" 
                name="Title" 
                onChange={e => this.url(e)} 
                // style={{width: "180px", marginLeft: "10px"}}
                style={{
                  width: "200px",
                  fontFamily: "arial",
                  fontWeight: "250",
                  color: "#784feb",
                  fontSize: "12px",
                  border: "2px solid rgb(206, 204, 204)",
                  borderRadius: "4px",
                  // height: "30px",
                  paddingBottom: "0px",
                  placeholder: "Required"
                }}
                />
            </div>
            <div 
              className="d-flex justify-content-around mb-3"
            >
                <label className="basicParagraph" style={{width: "150px"}}>Enter a brief description: </label>
                <textarea 
                type="text" 
                name="Title" 
                onChange={e => this.description(e)} 
                // style={{width: "180px", marginLeft: "10px"}}
                style={{
                  width: "200px",
                  fontFamily: "arial",
                  fontWeight: "250",
                  color: "#784feb",
                  fontSize: "12px",
                  border: "2px solid rgb(206, 204, 204)",
                  borderRadius: "4px",
                  // height: "30px",
                  paddingBottom: "0px",
                  placeholder: "Required"
                }} 
                />
            </div>
            {/* <button type="button" className="btn btn-success btn-block" onClick={this.onClickHandler} disabled={this.state.loaded ? false : true}>Save</button> */}
            <button
                // className="btn btn-primary shadow-none"
                className="btn btn-outline-success btn-md"
                style={{
                }}
                onClick={this.onClickHandler}
                disabled={this.state.loaded ? false : true}
              >
                Save
              </button>
            {!this.state.loaded && (
              <p>Video is being saved, please wait.</p>
            )}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
